import { RecentRecord, RecentRecordService } from "@/services/recent-record";
import { getObjectMetadata } from "@/utils/content-types";
import { LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

interface RecentRecordsProps {
    objectType: string;
}

export function RecentRecords({ objectType }: RecentRecordsProps) {
    const [records, setRecords] = useState<RecentRecord[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Récupérer les métadonnées de l'objet une seule fois
    const objectMetadata = getObjectMetadata(objectType);

    useEffect(() => {
        console.log("RecentRecords objectType", objectType);
        const fetchRecentRecords = async () => {
            try {
                setLoading(true);
                setError(null);
                console.log("Fetching recent records for objectType:", objectType);
                const data = await RecentRecordService.byReferenceType(objectType);
                console.log("Received data:", data);
                setRecords(data);
            } catch (err) {
                setError("Error loading recent records");
                console.error("Error recent records:", err);
                console.error("Error details:", {
                    objectType,
                    error: err
                });
            } finally {
                setLoading(false);
            }
        };

        if (objectType) {
            fetchRecentRecords();
        }
    }, [objectType]);

    if (loading) {
        return (
            <div className="flex items-center justify-center p-2">
                <LoaderCircle className="h-4 w-4 animate-spin" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="px-2 py-1.5 italic text-red-400">
                <p className="text-sm">Error loading recent records</p>
            </div>
        );
    }

    if (!records || records.length === 0) {
        return (
            <div className="px-2 py-1.5 italic text-gray-300">
                <p className="text-sm">No recent records</p>
            </div>
        );
    }

    return (
        <>
            {records.map(record => {
                const IconComponent = objectMetadata.icon;
                return (
                    <div key={record.id} className="overflow-hidden rounded-md hover:bg-gray-100">
                        <NavLink
                            to={record.object_url}
                            className="flex cursor-pointer flex-row items-center gap-2 p-1.5 px-2 text-sm text-gray-800 hover:text-black"
                            title={record.object_name} // Tooltip pour voir le nom complet
                        >
                            <div className="flex h-6 w-6 items-center justify-center rounded-sm px-1 text-sm font-medium" style={{ backgroundColor: objectMetadata.color }}>
                                <IconComponent size={14} className="text-white" strokeWidth={2} />
                            </div>
                            <div className="max-w-56 truncate">{record.object_name}</div>
                        </NavLink>
                    </div>
                );
            })}
        </>
    );
}
